export default (el) => {
  const random = (min, max) => Math.floor(Math.random() * (max - min)) + min
  const flashNumber = random(70, 100)
  const flashTextEl = el.querySelector('.js-flash-text')
  const flashProgressbarEl = el.querySelector('.js-flash-progressbar')

  flashTextEl.innerHTML = 'Còn '+ flashNumber +'/100 suất'
  flashProgressbarEl.style.width = flashNumber + '%'
}
